import * as yup from 'yup';

export const CreateEditPatientValidationSchema = yup.object().shape({
	first_name: yup
		.string()
		.trim()
		.required('First name is required')
		.min(2, 'First name must be at least 2 characters')
		.max(255, 'First name must be less than 255 characters'),
	last_name: yup
		.string()
		.trim()
		.required('Last name is required')
		.min(2, 'Last name must be at least 2 characters')
		.max(255, 'Last name must be less than 255 characters'),
	age: yup
		.number()
		.required('Age is required')
		.min(1, 'Age must be at least 1')
		.max(120, 'Age must be less than 120'),
	gender: yup
		.string()
		.trim()
		.required('Gender is required')
		.oneOf(['male', 'female', 'other'], 'Please select a valid gender'),
	contact_number: yup
		.string()
		.trim()
		.transform((value) => (value === '' ? null : value))
		.optional()
		.nullable()
		.min(8, 'Contact number must be at least 8 characters')
		.max(20, 'Contact number must be less than 20 characters'),
	address: yup
		.string()
		.trim()
		.transform((value) => (value === '' ? null : value))
		.optional()
		.nullable()
		.min(2, 'Address must be at least 2 characters')
		.max(255, 'Address must be less than 255 characters'),
	occupation: yup
		.string()
		.trim()
		.transform((value) => (value === '' ? null : value))
		.optional()
		.nullable()
		.min(2, 'Occupation must be at least 2 characters')
		.max(255, 'Occupation must be less than 255 characters'),
});
